import { TillageEvent } from '@cibo/core'
import { Stack, Tooltip, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface TillageCellDisplayProps {
  value: any
}

export const TillageCellDisplay = ({ value }: TillageCellDisplayProps) => {
  const { t } = useTranslation(['@cibo/landmanager', '@cibo/landmanager/TillageEditor'])

  if (value?.source === 'cibo') {
    return (
      <Stack>
        <Typography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {t(value?.result)}
        </Typography>
      </Stack>
    )
  } else if (value.result) {
    return (
      <TillageSummary value={value}>
        <Stack>
          <Typography
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {t(`tillage_${value?.result}`)}
          </Typography>
          {value.input?.events?.length ? (
            <Typography variant="caption">
              {t('events', { count: value.input?.events?.length })}
            </Typography>
          ) : (
            ''
          )}
        </Stack>
      </TillageSummary>
    )
  } else if (value.input) {
    return (
      <TillageSummary value={value}>
        <Typography variant="body1">
          {t('events', { count: value.input?.events?.length })}
        </Typography>
      </TillageSummary>
    )
  }
}

const TillageSummary = ({
  value,
  children,
}: TillageCellDisplayProps & { children: ReactElement }) => {
  const { t } = useTranslation(['@cibo/landmanager', '@cibo/landmanager/TillageEditor'])
  return (
    <Tooltip
      title={
        <Stack spacing={1} padding={1}>
          {value.input?.events.map(
            (
              { date, implement, depth, rowSpacing, stripWidth, residueRemaining }: TillageEvent,
              index: number
            ) => (
              <Stack key={index}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  {t('eventDate', { date: new Date(date) })}
                </Typography>
                <Typography variant="body2">
                  {implement !== 'stripTill'
                    ? t(implement, { ns: '@cibo/landmanager/TillageEditor' })
                    : t('stripTillSummary', {
                        ns: '@cibo/landmanager/TillageEditor',
                        rowSpacing,
                        stripWidth,
                      })}
                  {depth || residueRemaining ? ' - ' : ''}
                  {residueRemaining &&
                    `${t('residueRemaining', {
                      value: residueRemaining,
                      ns: '@cibo/landmanager/TillageEditor',
                    })}`}{' '}
                  {depth &&
                    `${t('depth', { value: depth, ns: '@cibo/landmanager/TillageEditor' })}`}
                </Typography>
              </Stack>
            )
          )}
        </Stack>
      }
    >
      {children}
    </Tooltip>
  )
}
